import { FaHeart } from 'react-icons/fa';

function Footer() {
  return (
    <footer>
      <small>
        {/* &copy; {new Date().getFullYear()} Done with{' '}
        <FaHeart style={{ color: 'red' }} /> by -{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://granada.com.gt/es/"
        >
          Ahmed SA | AH 
        </a> */}
      </small>
    </footer>
  );
}

export default Footer;
